import { jsx as _jsx } from "react/jsx-runtime";
import * as TabsPrimitives from "@radix-ui/react-tabs";
import React from "react";
import { tv } from "tailwind-variants";
import { cn } from "../../utils";
const Tabs = (props) => {
    return _jsx(TabsPrimitives.Root, { "tremor-id": "tremor-raw", ...props });
};
Tabs.displayName = "Tabs";
const TabsListVariantContext = React.createContext("line");
const listVariants = tv({
    base: "items-center",
    variants: {
        variant: {
            line: " flex justify-start border-b border-gray-4",
            outlined: "inline-flex justify-center p-px",
        },
    },
});
const TabsList = React.forwardRef(({ className, variant = "line", children, ...props }, forwardedRef) => (_jsx(TabsPrimitives.List, { ref: forwardedRef, className: cn(listVariants({ variant }), className), ...props, children: _jsx(TabsListVariantContext.Provider, { value: variant, children: children }) })));
const triggerVariants = tv({
    base: cn(
    // base
    "justify-center items-center transition-all text-sm whitespace-nowrap font-bold", 
    // disabled
    "disabled:cursor-not-allowed disabled:text-gray-8"),
    variants: {
        variant: {
            line: cn(
            // base
            "-mb-px items-center border-b-2 border-transparent px-5 ", 
            // text
            "text-gray-11", 
            // hover
            "hover:data-[state=inactive]:enabled:text-gray-10 hover:data-[state=inactive]:enabled:border-gray-5", 
            // selected
            "data-[state=active]:border-primary-9 data-[state=active]:text-primary-9"),
            outlined: cn(
            // base
            "inline-flex px-5 ring-1 first:rounded-l-lg last:rounded-r-lg mx-[0.5px]", 
            // outline border
            "outline outline-1 outline-gray-7", 
            // text
            "leading-button-md text-gray-11", 
            // ring
            "ring-transparent ring-inset", 
            // hover
            "hover:data-[state=inactive]:enabled:text-gray-10", 
            // selected
            "data-[state=active]:bg-primary-5 data-[state=active]:outline-primary-8 data-[state=active]:text-primary-11 data-[state=active]:relative", 
            // disabled
            "disabled:bg-gray-4 disabled:outline-gray-7"),
        },
        size: {
            sm: "h-8",
            md: "h-10",
        },
    },
    defaultVariants: {
        size: "md",
    },
});
const TabsTrigger = React.forwardRef(({ className, children, size, ...props }, forwardedRef) => {
    const variant = React.useContext(TabsListVariantContext);
    return (_jsx(TabsPrimitives.Trigger, { ref: forwardedRef, className: cn(triggerVariants({ variant, size }), className), ...props, children: children }));
});
const TabsContent = React.forwardRef(({ className, ...props }, forwardedRef) => _jsx(TabsPrimitives.Content, { ref: forwardedRef, className: cn("outline-none", className), ...props }));
TabsTrigger.displayName = "TabsTrigger";
TabsList.displayName = "TabsList";
TabsContent.displayName = "TabsContent";
export { Tabs, TabsContent, TabsList, TabsTrigger };
export default Tabs;
